// extracted by mini-css-extract-plugin
export default {"drawer":"change-password-drawer_drawer__Rii-2","footerWrapper":"change-password-drawer_footerWrapper__b-BD+","footerBackButton":"change-password-drawer_footerBackButton__28KYT"};